import * as React from "react";
import { Box } from "@mui/material";

import { shellGap } from "@/layouts/shellPanels";

/** The shell's right column: the host a page portals its panels into
 *  (see ``rightColumnSlot``). It has no surface of its own: the page
 *  puts one or more panels in it (the session view: Session context,
 *  Artifacts, People), each with ``shellPanelSx``, 15px apart. The host
 *  itself neither scrolls nor clips, so a collapse button can sit half
 *  outside its left edge: the page puts its own scroll box inside (the
 *  session view's panel stack scrolls as one). Shown only
 *  while a page claims it, and only from lg (1200px): below that the
 *  page shows its panels another way (the session view: a drawer, or a
 *  tab on phones). */
export function ShellRightColumn({
  claimed,
  ref,
}: {
  claimed: boolean;
  ref: React.Ref<HTMLElement>;
}): React.JSX.Element {
  return (
    <Box
      ref={ref}
      component="aside"
      data-testid="shell-right-column"
      sx={{
        display: claimed ? { xs: "none", lg: "flex" } : "none",
        flexDirection: "column",
        gap: shellGap,
        flexShrink: 0,
        minHeight: 0,
        position: "relative",
      }}
    />
  );
}
